import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {
  AwsApiWrapperService
} from "@brightside-web/desktop/data-access/core-services";
import {CreditSetupStatus, FirebaseService} from "@brightside-web/desktop/data-access/shared";


@Injectable()
export class VerifySmfaService {

  private polling = false;
  private pollingMS: number = 60000; // defaulting to 1 minute

  private _smfa: BehaviorSubject<string> = new BehaviorSubject<string>('')
  public readonly smfa: Observable<string> = this._smfa.asObservable();
  public stopPolling: boolean = false;
  constructor(
    private analytics: FirebaseService,
    private awsApiWrapperService: AwsApiWrapperService) {
    const pollFreq = Number(this.analytics.getValueAsString('smfaPollFrequency'));
    if (pollFreq) {
      this.pollingMS = pollFreq * 1000;
    }
  }

  pollVerifySMFA(isIterating = false) {
    if (this.polling && !isIterating) return;
    if (this.stopPolling) {
      this.polling = false;
      return;
    }

    this.polling = true;
    this.awsApiWrapperService.get('api-mobile', '/credit/subscription', {}).then(
      value => {
        if (value?.status !== CreditSetupStatus.VERIFY_SMFA) {
          this.polling = false;
          this._smfa.next(value?.status);
        } else {
          setTimeout(() => {
            this.pollVerifySMFA(true);
          }, this.pollingMS);
        }
      }
    )
  }
}
